import {createSelector} from '@reduxjs/toolkit'
import { currentAgentApplicationSelector } from './collectorApplicationSelector'

const collectorDetailsSelector = createSelector(
    [state => state.components,
        currentAgentApplicationSelector],
    (components, agentApplication) => {

        return Object.assign({},
            components.collectorDetails,
            {
                applicantDetails : agentApplication?.businessLicenceData?.personData,
                applicantCriminalHistoryData : agentApplication?.businessLicenceData?.criminalHistoryData
            }
        )
    }
)

export const collectorDetailsSelect = state => ({
    collectorDetails: collectorDetailsSelector(state)
})

export function populateAgentDetailsForReview (agentData) { 
    const {personData} = agentData

    return {
        "First name" :  personData.firstName,
        "Last name" : personData.lastName,
        "Email address" : personData.email,
        "Street address" : personData.addressData.address1,
        "City/Town" : personData.addressData.cityName,
        "State" : personData.addressData.stateName,
        "Postal code" : personData.addressData.postalCode,
        "Phone number" : personData.phoneNumber
    }
}
